import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Local copy of studio's `cn`. Identical implementation, deliberately not
 * imported from the app: this package is a DEPENDENCY of studio, so importing
 * back out of it would be a cycle.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
